import { render, staticRenderFns } from "./InvestmentAccountLink.vue?vue&type=template&id=021ceb29&scoped=true"
import script from "./InvestmentAccountLink.vue?vue&type=script&lang=ts"
export * from "./InvestmentAccountLink.vue?vue&type=script&lang=ts"
import style0 from "./InvestmentAccountLink.vue?vue&type=style&index=0&id=021ceb29&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "021ceb29",
  null
  
)

export default component.exports